import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestChecklistGet = {
    path: "/checklist",
    method: RouteHttpVerb.GET
};
